<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/qtbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'资源预约平台'"></detailBread>
        <div class="container">
            <div class="page-title">
                资源预约平台
            </div>
            <div class="page-content">
                <img src="../../../static/images/qtywly-zyyypt-01.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '资源预约平台', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '资源预约平台'
        },
        {
            name: 'description',
            content: '资源预约平台'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'3',
        }
    },
     methods: {
        topback(){
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
/* @import url('bootstrap/dist/css/bootstrap.min.css'); */
@import url('../../../static/css/bootstrap.min.css');
@import url('../../assets/css/old/reset.css');
@import url('../../assets/css/old/all.css');
</style>


// WEBPACK FOOTER //
// src/pages/old/zyyypt.vue